import { ErrorType, LoadedType, RequestType } from 'common/actions/zoomSettings';

import requestReducerFactory from './requestReducerFactory';

export default requestReducerFactory(RequestType, LoadedType, ErrorType);
